export default __webpack_public_path__ + "static/media/30.05171de6.svg";